import { StepType } from 'src/app/shared/shared.module';
import {
  getInputField, setAsRequired,
  getSelectField, setRequiredWhen, setDisableWhen, setStatusTypeValidation, setImmStatusTypeValidation, setAsDisabled,
  MinumumAgeMustBe,
  setRegexValidation,
  setAsHiddenWhen,
  setAsHiddenWithoutValueWhen,
  getTelephoneField,
  setAsRequiredEmail,
  setDisableImmigrationCaseTypeWithValueWhen
} from 'src/app/shared/form';
import { VisaType } from '../../visatypes';
import { isNullOrUndefined } from '../../../../../../app/core/utils';
import { map } from 'rxjs/operators';
import { FieldTooltip } from '../../field-tooltip.enum';


export class VisaPreApproval extends VisaType {

  GetRequesterSteps(): StepType[] {

    return [
      {
        label: "Step 1",
        fields: [
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              this.firstName(),
              this.middleName(),
              this.lastName()
            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              this.nationality(),
              getSelectField(
                "dualCitizenship.id",
                "Dual citizenship",
                this.common.getSelectFieldOptions(this.yesNo$, '',
                  setAsRequired(this.addFieldTooltipWithAdditionalConfig('Dual citizenship')))
              ),
              getSelectField(
                "secondNationality.id", "Second nationality",
                this.common.getSelectFieldOptionsExcept(this.nationality$, 'nationality.id',
                  this.addFieldTooltipWithAdditionalConfig('Second nationality',setDisableWhen((model) => !isNullOrUndefined(model.dualCitizenship) && model.dualCitizenship.id !== 1074,
                    setRequiredWhen((model) => !isNullOrUndefined(model.dualCitizenship) && model.dualCitizenship.id === 1074)
                  ))
              ))
            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              getInputField("passportNumber", "Passport number",this.addFieldTooltipWithAdditionalConfig('Passport number')),
              getInputField("placeOfBirth", "Place of birth (City,Country)", this.addFieldTooltipWithAdditionalConfig('Place of birth')),
              this.gender(),
              getTelephoneField("Mobile number", setAsRequired(this.addFieldTooltipWithAdditionalConfig('Mobile number'))),
              getInputField("emailAddress", "Email ID", setAsRequiredEmail(this.addFieldTooltipWithAdditionalConfig('Email ID'))),
           
              getSelectField(
                "serviceLine.id",
                "Service line",
                this.common.getSelectFieldOptions(this.serviceLines$, '',
                  setAsRequired())
              ),
              getSelectField(
                "subServiceLine.id",
                "Sub-service line",
                this.common.getSelectFieldOptions(this.subServiceLines$, "serviceLine.id",
                  setAsRequired())
              ),
              this.rank(),
              this.officeLocation(),
              this.officeLE('EY legal entity'),
              getInputField("academicQualification", "Academic qualification", setAsRequired(this.addFieldTooltipWithAdditionalConfig('Academic qualification'))),
              getSelectField(
                "distanceLearning.id",
                "Was the academic qualification obtained via distance learning",
                this.common.getSelectFieldOptions(this.yesNo$, '',
                  setAsRequired({ className: 'col-md-4 mb-3 text-sm lengthy-label' }))
              ),
             
            ]
          }]
      },
      {
        label: "Step 2",
        fields: [
          {
            fieldGroupClassName: "row",
            fieldGroup: [
            
              // this.grade(),
             
              getSelectField(
                "currentGccResident.id",
                "Is new joiner a current GCC resident?",
                this.common.getSelectFieldOptions(this.yesNo$, '', setAsRequired())
              ),
              // getInputField(
              //   "gccResidencyTitle",
              //   "GCC residency Job title (for GCC residents only)",
              //   this.common.isAccessible()
              // ),
              // getInputField(
              //   "gccSponsorName",
              //   "GCC Visa Sponsor name (for GCC residents only)",
              //   this.common.isAccessible()
              // )

              getSelectField("employeeCurrentLocationCountry.id", "Candidate's current location",
                this.common.getSelectFieldOptions(this.globalEmployeeLocationCountries$, '', this.addFieldTooltipWithAdditionalConfig('Candidate current location'))
              ), 
              getSelectField(
                "eyInternalTransfer.id",
                "EY Internal Transfer",
                this.common.getSelectFieldOptions(this.yesNo$, '',
                  setAsRequired())
              ),         
              getSelectField("immigrationCaseType.id", "Immigration case type",this.common.getRequiredSelectFieldOptions(this.immigrationCaseTypeVisaPreApproval$,setAsRequired(
                setDisableImmigrationCaseTypeWithValueWhen((model) => this.checkIsKSAPreApprovalChild(model))
              ))),          
              // getSelectField("immigrationCaseType.id", "Immigration case type",
              //   this.common.getSelectFieldOptionsWithDisable(this.immigrationCaseTypeVisaPreApproval$.pipe(map(item => item.filter(i => [1004,1005,1016,1017,12266,12267,12268,12269].includes(i.id)))), [1004,1005,1016,1017],
              //   setAsRequired())
              // ),

              getSelectField(
                "embassy.id",
                "Embassy/Consulate (country)",setAsRequired(
                this.common.getSelectFieldOptions(this.nationality$, '',                         
                setRequiredWhen((model) => (!isNullOrUndefined(model.currentGccResident) && model.currentGccResident.id === 1074),this.addFieldTooltipWithAdditionalConfig('Embassy/Consulate (country)'))))),
               this.cityOfEmbassy(),
                
                    // getInputField("visaNumber", "Visa number",
                    //  setAsDisabled()
                    // ),
                    // getInputField("visaDesignation", "Visa designation",
                    //   setAsDisabled()
                    // ),
                    getSelectField("recruiter.id", "Recruiter name", setAsRequired(this.common.getEmployeeSelectFieldOptions(this.recruiters$))),
                    this.pjcName('PJC name',
                    setRequiredWhen((model) => (!isNullOrUndefined(model.immigrationCaseType) && model.immigrationCaseType.id === 12266),setDisableWhen((model) => (!isNullOrUndefined(model.immigrationCaseType) && model.immigrationCaseType.id !== 12266))
                    )),

                    this.RequestorName(),
            ]
          }
        ]
      },
    ];
  }


  GetAccepterSteps(): StepType[] {
    return [
      {
        label: "Step 1",
        fields: [
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              this.visaProcessorByOfficeLE(setAsRequired()),
              //  this.Requestor()
            ]
          }
        ]
      }
    ];
  }



  GetApproverSteps(): StepType[] {

    return [
      {
        label: "Step 1",
        fields: [
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              this.visaProcessorByOfficeLE(
                setAsRequired()
                ),
                this.immigrationStatus(),
              getInputField("residencyDesignation",
                "Residency (Iqama) designation",
                null),
              
                getInputField("visaNumber", "Visa number",
                setRequiredWhen((model) => !isNullOrUndefined(model.immigrationCaseType) && model.immigrationCaseType.id == 12266,
                    setDisableWhen((model) => this.itIsIqama(model))
                  )),
  
  
                getInputField("visaDesignation", "Visa designation",
                setRequiredWhen((model) => !isNullOrUndefined(model.immigrationCaseType) && model.immigrationCaseType.id == 12266,
                    setDisableWhen((model) => this.itIsIqama(model))
                  )),
                
                //new
                getInputField("certificateForVisaTagging","Certificate for Visa Tagging",setAsRequired())
              // this.Requestor()

            ]
          }
        ]
      }
    ];
  }

  itIsIqama(model) {
    return (!isNullOrUndefined(model.immigrationCaseType)
      && [12267, 12268].includes(model.immigrationCaseType.id));
  }
  checkIsKSAPreApprovalChild(model) {
      return (!isNullOrUndefined(model.autorequestCompleted) ? this.checkChild(model.autorequestCompleted.trim()) : false);
  }
  checkChild(v:string){
    return (v === 'KSA_VPA_C') ? true : false;
  }
}
